export interface ApiErrorData {
  code: string;
  message: string;
}

export class ApiError extends Error {
  code: string;
  message: string;

  constructor(e: ApiErrorData) {
    super();

    this.code = e.code;
    this.message = e.message;
    if (!e.message) {
      this.message = `[${e.code}]`;
    }
  }
}

export class NotFound extends ApiError {}

export class InvalidParam extends ApiError {
  params: Record<string, any>;

  constructor(e: any) {
    super(e);
    this.params = e.params;
  }

  captcha_required() {
    return this.params?.captcha_required ? true : false;
  }

  captcha_error() {
    return this.params?.captcha_error ? true : false;
  }

  captcha_retry() {
    return this.params?.captcha_retry ? true : false;
  }
}

export class LoginRequired extends ApiError {}

export class TooManyRequests extends ApiError {
  message: string;
  retry_after: number;

  constructor(e: any) {
    super(e);
    this.message = e.message.message;
    this.retry_after = e.message.retry_after;
  }
}

export function makeApiError(e: ApiErrorData) {
  switch (e.code) {
    case 'NOT_FOUND':
      return new NotFound(e);
    case 'INVALID_PARAM':
      return new InvalidParam(e);
    case 'LOGIN_REQUIRED':
      return new LoginRequired(e);
    case 'TOO_MANY_REQUESTS':
      return new TooManyRequests(e);
    default:
      return new ApiError(e);
  }
}
